module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "30px",
      "height": "30px"
    }
  }, [(!_vm.isRecording) ? _c('i', {
    staticClass: "material-icons btnRecord",
    on: {
      "click": _vm.startRecording
    }
  }, [_vm._v("mic")]) : _c('i', {
    staticClass: "material-icons btnRedRecord",
    on: {
      "click": _vm.stopRecording
    }
  }, [_vm._v("fiber_manual_record")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5afa9bb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recorder.vue
// module id = 894
// module chunks = 2